import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import { SEARCH_INDEX_DELAY } from '../../consts';
import DELETE_OBJECTIVE_MUTATION from '../mutations/DELETE_OBJECTIVE_MUTATION';
  
const useDeleteObjective = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( DELETE_OBJECTIVE_MUTATION );

    const handleObjective = async ( id, onFinishCallback ) => {
        setIsDeleting( true );
        
        try {
            await deleteMutation( { variables: { input: { id: id } } } );
            
            setTimeout( () => {
                if ( onFinishCallback ) { onFinishCallback(); }
                setIsDeleting( false );
            }, SEARCH_INDEX_DELAY );
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting objective!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteObjective: handleObjective
        };
    }, [ isDeleting ] );
};

export default useDeleteObjective;
